'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contact = void 0;
const Func = require("../../func");
const $ = require("jquery");
class Contact {
    constructor(
    // 空白チェック項目
    notNullKeys = [
        'content_of_inquiry',
        'your_name',
        'your_name_kana',
        'company',
        'email',
        'detail',
        'accept',
    ], notNullKeysEn = [
        'content_of_inquiry',
        'your_name',
        'company',
        'email',
        'detail',
        'accept',
    ]) {
        this.notNullKeys = notNullKeys;
        this.notNullKeysEn = notNullKeysEn;
        $('#trigContactSubmit').on('click', (e) => {
            $('.bulletContactErrorMessage').hide();
            const lang = $(e.currentTarget).attr('data-lang');
            if (lang !== 'en') {
                const values = this.getValues();
                return this.validates(values);
            }
            else {
                const values = this.getValuesEn();
                return this.validatesEn(values);
            }
        });
    }
    getValues() {
        return {
            content_of_inquiry: $('.paramContactValue[data-name="content_of_inquiry"]:checked').val(),
            your_name: $('.paramContactValue[data-name="your_name"]').val(),
            your_name_kana: $('.paramContactValue[data-name="your_name_kana"]').val(),
            company: $('.paramContactValue[data-name="company"]').val(),
            email: $('.paramContactValue[data-name="email"]').val(),
            tel: $('.paramContactValue[data-name="tel"]').val(),
            detail: $('.paramContactValue[data-name="detail"]').val(),
            accept: $('.paramContactValue[data-name="accept"]:checked').val(),
        };
    }
    getValuesEn() {
        return {
            content_of_inquiry: $('.paramContactValue[data-name="content_of_inquiry"]:checked').val(),
            your_name: $('.paramContactValue[data-name="your_name"]').val(),
            company: $('.paramContactValue[data-name="company"]').val(),
            email: $('.paramContactValue[data-name="email"]').val(),
            tel: $('.paramContactValue[data-name="tel"]').val(),
            detail: $('.paramContactValue[data-name="detail"]').val(),
            accept: $('.paramContactValue[data-name="accept"]:checked').val(),
        };
    }
    validates(values) {
        let errorName = '';
        // 空白チェック
        this.notNullKeys.forEach(function (v) {
            if (Func.isNull(values[v])) {
                $('.bulletContactErrorMessage[data-name="' + v + '"]').show();
                if (!errorName) {
                    errorName = v;
                }
            }
        });
        // メールフォーマット
        if (!Func.isNull(values.email) && !Func.matchEmailFormat(values.email)) {
            $('.bulletContactErrorMessage[data-name="email_not_matched"]').show();
            if (!errorName) {
                errorName = 'email';
            }
        }
        // 電話番号フォーマット
        if (!Func.isNull(values.tel) && !Func.matchTelFormat(values.tel)) {
            $('.bulletContactErrorMessage[data-name="tel_not_matched"]').show();
            if (!errorName) {
                errorName = 'tel';
            }
        }
        //エラー時処理
        if (errorName) {
            this.scrollToError(errorName);
            return false;
        }
    }
    validatesEn(values) {
        let errorName = '';
        // 空白チェック
        this.notNullKeysEn.forEach(function (v) {
            if (Func.isNull(values[v])) {
                $('.bulletContactErrorMessage[data-name="' + v + '"]').show();
                if (!errorName) {
                    errorName = v;
                }
            }
        });
        // メールフォーマット
        if (!Func.isNull(values.email) && !Func.matchEmailFormat(values.email)) {
            $('.bulletContactErrorMessage[data-name="email_not_matched"]').show();
            if (!errorName) {
                errorName = 'email';
            }
        }
        // 電話番号フォーマット
        if (!Func.isNull(values.tel) && !Func.matchTelFormat(values.tel)) {
            $('.bulletContactErrorMessage[data-name="tel_not_matched"]').show();
            if (!errorName) {
                errorName = 'tel';
            }
        }
        //エラー時処理
        if (errorName) {
            this.scrollToError(errorName);
            return false;
        }
    }
    scrollToError(errorName) {
        const formPosition = $('.bulletContactError[data-name="' + errorName + '"]').offset().top;
        console.log(formPosition);
        const headerHeight = $('.paramHeader').outerHeight() || 0;
        $('html, body').animate({
            scrollTop: formPosition - headerHeight
        }, 'slow');
    }
}
exports.Contact = Contact;
exports.default = Contact;
